import PageSideMenu from "./PageSideMenu";

export default PageSideMenu;
